<template>
  <div class="filelist">
    <b-table tbody-tr-class="filelisttable" fixed striped hover :fields="fields" :items="files" @row-clicked="viewResult">
      <template v-slot:cell(date)="data">
        {{ data.item.date}}
      </template>
      <template v-slot:cell(local_filename)="data">
        {{ data.item.filename }}
      </template>
      <template v-slot:cell(status)="data">
        <div :class="data.item.status">{{ data.item.status }}</div>
      </template>
    </b-table>
  </div>
</template>

<script>
import firebase from 'firebase'
import axios from 'axios'
import moment from 'moment'
const apiUrl = 'https://logcrow.appspot.com/'
// const apiUrl = 'http://192.168.212.101:9999/'
// const apiUrl = 'http://localhost:9999/'
export default {
  name: 'FileList',
  props: {},
  data() {
    return {
      fileInfos: [],
      getFileInfoListTimer: null,
      fields: [
        {key: 'date', label: 'Date'},
        {key: 'local_filename', label: 'File name'},
        {key: 'status', label: 'Status' }
      ]
    }
  },
  methods: {
    makeToast(variant = null, message) {
      this.$root.$bvToast.toast(message, {
        title: `${variant || 'message'}`,
        variant: variant,
        solid: true
      })
    },
    convertStatusStr(status) {
      if( status === 0 ) {
        return "uploaded"
      } else if( status === 1 ) {
        return "analyzing"
      } else if( status === 2 ) {
        return "analyzed"
      }
    },
    getFileInfoList() {
      let currentUser = firebase.auth().currentUser
      if (currentUser) {
        currentUser.getIdToken(true).then(async (idToken) => {
          let res = await axios.get(apiUrl + 'fileinfo', {
            headers: {
              'Authorization': `Bearer ${idToken}`,
              'Content-Type': 'application/json'
            }
          })
          this.fileInfos = res.data
          let allFinished = true
          if (this.fileInfos.length > 0) {
            let items = []
            for ( let fileInfo of this.fileInfos ) {
              let item = {}
              item.date = moment(fileInfo.uploaded_at).format("YYYY/MM/DD HH:mm:ss")
              item.filename = fileInfo.local_filename
              item.status = this.convertStatusStr(fileInfo.status)
              item.fileId = fileInfo.fileId
              items.push(item)
              if( fileInfo.status  !== 2 ) {
                allFinished = false
              }
            }
            this.$store.commit('setFiles', items)
            if( allFinished === true ) {
              clearInterval(this.getFileInfoListTimer)
              this.getFileInfoListTimer = null
            } else {
              if( this.getFileInfoListTimer == null ) {
                this.getFileInfoListTimer = setInterval(this.getFileInfoList, 30000)
              }
            }
          } else {
            this.makeToast('warning', "No uploaded files...")
          }
        }).catch(() => {
          this.makeToast('warning', "Failed to get uploaded file info...")
        })
      }
    },
    viewResult(record) {
      if( record.status === "analyzed" ) {
        this.$router.push({name: 'AnalyzedResult', params: {fileid: record.fileId}})
      }
    }
  },
  computed: {
    files() {
      return this.$store.getters.files
    },
  },
  mounted: function() {
    this.getFileInfoList()
    this.getFileInfoListTimer = setInterval(this.getFileInfoList, 30000)
  },
  destroyed() {
    clearInterval(this.getFileInfoListTimer)
    this.$store.commit('setFiles', [])
  },
}
</script>

<style>
.filelisttable {
  cursor: pointer;
}
.uploaded {
  animation:blink 1s ease-in-out infinite alternate;
}
.analyzing {
  animation:blink 1s ease-in-out infinite alternate;
}
@keyframes blink{
  0% {opacity:0;}
  100% {opacity:1;}
}
</style>
